import BaseForm from './baseForm';
import * as Choices from 'choices.js';

export default class ContactUsForm extends BaseForm {

  constructor() {
    super('contact-us-form');
  }

  init() {
    super.init('contact-us-form');
    let select = document.querySelector('#subjects');
    if (select) {
      new Choices(select, {
        searchEnabled: false,
        itemSelectText: '',
        labelId: 'subject-label',
      });
    }

    select = document.querySelector('#type');
    if (select) {
      new Choices(select, {
        searchEnabled: false,
        itemSelectText: '',
        labelId: 'type-label',
      });

      let subjectField = document.querySelector("[aria-labelledby='subject-label']");
      subjectField.setAttribute("aria-describedby", "subject-error");
      subjectField.setAttribute("aria-required", "true");
    }
  }

  getFormValidationConstraints() {
    return {
      ...this.notEmptyConstraint('name'),
      ...this.notEmptyConstraint('lastname'),
      ...this.emailConstraint('email'),
      ...this.notEmptyConstraint('subjects'),
      ...this.notEmptyConstraint('message')
    };
  }
}
